import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IRegisterUser {
    active_count?: number
    accumulate_count?: number
    day?: number
}
export const getRegiserUser = async (limit: number): Promise<ApiRes<IRegisterUser[]>> => {
    return await apiGet(API_URL, `admin/register_user/graph?limit=${limit}`)
}
